// about widget content
export const aboutHTML = [
   '<p><b>Welcome!</b></p>',
   '<p>This tool provides you with a view of all Service Center locations and Weather warnings / watches across the United States and Canada territories.</p>',
   '<p>If you have any comments, suggestions, or questions, please reach out to us at <a href="mailto:LTLBIFAST@xpo.com?subject=LTL%20Service%20Level%20Map&amp;body=emailBody" target="_blank">LTLBIFAST@xpo.com</a></p>',
   '<p><small>Note: The data reflected here is refreshed every hour.</small>'
].join(" ");
